import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "collapsible", "expanded", "title"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import PanelTitle from './PanelTitle';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "16unk8l",
  styles: "position:relative;display:block"
} : {
  name: "1paidvf-rootStyles",
  styles: "position:relative;display:block;label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1BhbmVsSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQm1CIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1BhbmVsSGVhZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUGFuZWxUaXRsZSBmcm9tICcuL1BhbmVsVGl0bGUnO1xuXG50eXBlIE93blByb3BzID0ge1xuICBjaGlsZHJlbj86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgY2xhc3NOYW1lPzogc3RyaW5nO1xuICBjb2xsYXBzaWJsZT86IGJvb2xlYW47XG4gIGV4cGFuZGVkPzogYm9vbGVhbjtcbiAgdGl0bGU/OiBzdHJpbmc7XG59XG5cbnR5cGUgVW5oYW5kbGVkUHJvcHMgPSBPbWl0PFxuICBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4sXG4gIGtleW9mIE93blByb3BzXG4+O1xuXG50eXBlIFByb3BzID0gT3duUHJvcHMgJiBVbmhhbmRsZWRQcm9wcztcblxuY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICBkaXNwbGF5OiAnYmxvY2snLFxufSk7XG5cbmNvbnN0IFBhbmVsSGVhZGVyOiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBjaGlsZHJlbiA9IG51bGwsXG4gIGNvbGxhcHNpYmxlID0gZmFsc2UsXG4gIGV4cGFuZGVkID0gZmFsc2UsXG4gIHRpdGxlID0gJycsXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiAoXG4gIDxkaXYgey4uLnVuaGFuZGxlZFByb3BzfSBjc3M9e3Jvb3RTdHlsZXN9PlxuICAgIHtjaGlsZHJlbiAhPSBudWxsID8gY2hpbGRyZW4gOiAoXG4gICAgICA8UGFuZWxUaXRsZVxuICAgICAgICBjb2xsYXBzaWJsZT17Y29sbGFwc2libGV9XG4gICAgICAgIGV4cGFuZGVkPXtleHBhbmRlZH1cbiAgICAgICAgdGV4dD17dGl0bGV9IC8+XG4gICAgKX1cbiAgPC9kaXY+XG4pO1xuXG5QYW5lbEhlYWRlci5kaXNwbGF5TmFtZSA9ICdQYW5lbEhlYWRlcic7XG5cbmV4cG9ydCBkZWZhdWx0IFBhbmVsSGVhZGVyO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var PanelHeader = function PanelHeader(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : jsx(PanelTitle, {
    collapsible: collapsible,
    expanded: expanded,
    text: title
  }));
};

PanelHeader.displayName = 'PanelHeader';
export default PanelHeader;